"use client";

import { Play } from "lucide-react";
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

interface MediaUser {
	avatar: string;
	name: string;
	link: string;
	description: string;
}

const mediaUsers = (getTranslation: (key: string) => string): MediaUser[] => [
	{
		avatar: "https://pbs.twimg.com/profile_images/1857180072098279424/Jiod9DtJ_400x400.jpg",
		name: "ODIN•FUN",
		link: "https://x.com/Odin_GodOfRunes",
		description: getTranslation("plaza.officialMedia"),
	},
	{
		avatar: "https://pbs.twimg.com/profile_images/1919427162639368192/058lUhR6_400x400.jpg",
		name: "Bob Bodily",
		link: "https://x.com/BobBodily",
		description: getTranslation("plaza.founderShare"),
	},
	{
		avatar: "https://pbs.twimg.com/profile_images/1941050781006024705/_ie7aaAX_400x400.jpg",
		name: "BabyOdin",
		link: "https://x.com/BabyOdinfun",
		description: getTranslation("plaza.ctoMedia"),
	},
	{
		avatar: "https://pbs.twimg.com/profile_images/1988921857161179136/fQJYMC-m_400x400.jpg",
		name: "奥丁宝贝 BabyOdin_CTO",
		link: "https://x.com/BabyOdinCTO",
		description: getTranslation("plaza.communityMedia"),
	},
];

export function SidebarHotMedia() {
	const { getTranslation } = useLanguage();
	const mediaUsersList = mediaUsers(getTranslation);

	return (
		<Card className="rounded-2xl bg-light-surface dark:bg-dark-surface border-light-border dark:border-dark-border shadow-md">
			<CardContent className="p-6">
				<h3 className="font-bold text-light-text dark:text-dark-text flex items-center gap-2 mb-4">
					<Play className="h-5 w-5 text-status-info" />
					{getTranslation("plaza.hotMedia")}
				</h3>
				<div className="space-y-4">
					{mediaUsersList.map((user, index) => (
						<div
							key={index}
							className="flex items-center gap-3 p-2 rounded-xl hover:bg-light-background dark:hover:bg-dark-background transition-colors cursor-pointer"
							onClick={() => window.open(user.link, "_blank", "noopener,noreferrer")}
						>
							<Avatar className="h-10 w-10">
								<AvatarImage src={user.avatar || "/placeholder.svg"} />
								<AvatarFallback>{user.name.charAt(0)}</AvatarFallback>
							</Avatar>
							<div className="flex-1">
								<p className="font-medium text-light-text dark:text-dark-text text-sm hover:text-light-primary dark:hover:text-dark-primary transition-colors">
									{user.name}
								</p>
								<p className="text-xs text-gray-500">{user.description}</p>
							</div>
							<div className="text-gray-400 hover:text-light-primary dark:hover:text-dark-primary transition-colors">
								<svg
									width="16"
									height="16"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
									<polyline points="15,3 21,3 21,9"></polyline>
									<line x1="10" y1="14" x2="21" y2="3"></line>
								</svg>
							</div>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
}
